import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";

import { AccountPage } from "@common-components/account-page/account-page";
import BTThemeProvider from "@common-components/bt-theme-provider";
import classes from "../account-view/account-view.module.scss";

import { ApiWebhooksCard } from "./api-webhooks-card";
import { toggleSocketModal } from "@common-reducers/MainReducer";
import SocketConnectionStatusButton from "@common-components/socket-connection-status-button/socket-connection-status-button";

import { Session } from "@common-models/session";
import QrModal from "@common-views/qr-view/qr-modal";
import { selectCurrentUserSession } from "@common/reducers/UserSelectors";
import ConnectedEngines from "@common-components/connected-engines/connected-engines";
import { useTranslation } from 'react-i18next';
import { namespace } from '@common/config/constants';



const AdminApiView = () => {
  const { t, i18n } = useTranslation(namespace);
  const dispatch = useAppDispatch();
  const session: Session | undefined = useAppSelector(state => selectCurrentUserSession(state));
  const isSocketConnectedToWhatsApp = session?.active && session?.status === "connected";
  const isRtl = i18n.dir(i18n.language) === "rtl";

  const adminApiElement = () => {
    return (
      <div className={classes.pageContainer} dir={isRtl ? "rtl" : "ltr"}>
        {/* Header row */}
        <div className="flex flex-wrap items-start justify-between gap-4 px-4 sm:px-14 pt-6 sm:pt-8 pb-4 sm:pb-6 bg-[var(--page-header-bg)] border-b border-[var(--color-border)]">
          <div className="space-y-1 min-w-0">
            <h1
              className="text-2xl font-semibold tracking-tight text-[var(--color-text)]"
              style={{ unicodeBidi: 'plaintext' }}
            >
              {t('api.title')}
            </h1>
            <p
              className="text-sm text-[var(--color-text-muted)]"
              style={{ unicodeBidi: 'plaintext' }}
            >
              {t('api.subtitle')}
            </p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <ConnectedEngines />
            {isSocketConnectedToWhatsApp && (
              <div
                className="cursor-pointer"
                onClick={() => {
                  dispatch(toggleSocketModal(true));
                }}
              >
                <SocketConnectionStatusButton />
              </div>
            )}
          </div>
        </div>

        {/* Body */}
        <div
          className={classes.accountSettingBody}
          style={{ textAlign: isRtl ? 'right' : 'left' }}
        >
          <div className="space-y-6 mt-6">
            <ApiWebhooksCard />
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    document.title = t('api.title');
  }, [t]);

  return (
    <BTThemeProvider>
      <AccountPage
        page={adminApiElement()}
      ></AccountPage>
      <QrModal />
    </BTThemeProvider>
  );
};

export default AdminApiView;
